module.exports = __webpack_public_path__ + "img/teamImg29.6363541d.jpg";